import React from 'react';
import { Trans } from '../../../components/common';
import ServiceIcon from '../../../components/common/ServiceIcon/ServiceIcon';
import SummaryCard from '../../../components/common/Cards/SummaryCard/SummaryCard';

// Props: account, agency, ... (add more as needed)
const TXHHSSummaryCard = ({ account, agency }) => (
  <SummaryCard
    key={account.chipCase}
    className="summary-card-txhhs card-flat"
    outlined={false}
    graphic={
      <ServiceIcon
        className="agency-linked-services-item-icon flex-item"
        type="driver-license"
      />
    }
    horizontalList={true}
  >
    <div className="vehicle-details-txhhs">
      <SummaryCard.List
        fullWidth
        items={[
          {
            label: <Trans file="Labels" id="txhhs_chipCase" />,
            value: account.chipCase,
          },
        ]}
      />
      <SummaryCard.List
        className={`${agency.agencySlug}`}
        fullWidth
        items={[
          {
            label: <Trans file="Labels" id="txhhs_caseNumber" />,
            value: account.caseNumber,
          },
        ]}
      />
    </div>
  </SummaryCard>
);

export default TXHHSSummaryCard;
